import React, { useState } from "react";
import axios from "axios";

import {
    useRouteMatch,
} from "react-router-dom";


import logo from "../../images/logo-01.svg";
import { urls } from "../../config";
import CenterColumn from "../../components/CenterColumn";
import { Input, Text, Button } from "../../components/ui";
import Container from "../../components/Container";
// import moodleLogo from "../../images/logo.svg";

type Params = {
    email: string;
};


const Page = () => {
    const match = useRouteMatch<Params>();
    const passedEmail = match.params.email;

    const [email, setEmail] = useState(passedEmail || "");

    const [error, setError] = useState("");
    const [finished, setFinished] = useState(false);
    const [loading, setLoading] = useState(false);


    const submitReset = (ev) => {
        ev.preventDefault();
        setError("");
        if (email === "") {
            setError("Email is required.");
            return;
        }
        setLoading(true);
        axios.post(`${urls.remoteURL}users/forgot-password`, { email })
            .then((x) => {
                setFinished(true);
            })
            .catch((err) => {
                setError("Error.");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <Container classes={['content-center', 'items-center']}>
            <CenterColumn wrapClasses={['bg-gray-100', 'py-4', 'lg:py-12']}>
                <div className="flex flex-col md:flex-row ">
                    <div className="flex-1 text-center">
                        <img src={logo} className="px-8" alt="Nail Knowledge" />
                    </div>
                    <div className="w-5/6 md:w-auto block md:flex-1 self-center">
                        <Text className={`text-3xl mb-6`}>Check your email for the confirmation link</Text>

                        <Text className={`text-2xl mb-2 font-extralight text-center`}>Looking for your lessons?</Text>
                        <Button href={urls.rootURL} classes={['mt-4 w-full block text-center rounded']} disabled={loading} bgColor="bg-nailBlue-600" bgHoverColor="bg-nailBlue-700">Login here</Button>
                    </div>

                </div>
            </CenterColumn>
        </Container>
    );
};

export default Page;